import { render, staticRenderFns } from "./ModalInfoMailPreview.vue?vue&type=template&id=6690a0f4&"
import script from "./ModalInfoMailPreview.vue?vue&type=script&lang=js&"
export * from "./ModalInfoMailPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports